import React, { useRef, useEffect } from 'react';
import './sections.scss';
import { contentData } from './contentData';
import logo from '../../assets/logo.png';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Sections() {
  const logoRef = useRef();
  const containerRef = useRef();
  const animateRef1 = useRef();
  const animateRef2 = useRef();
  const animateRef3 = useRef();
  const animateRef4 = useRef();
  const animateRef5 = useRef();
  const sectionRef1 = useRef();
  const sectionRef2 = useRef();
  const sectionRef3 = useRef();
  const sectionRef4 = useRef();
  const sectionRef5 = useRef();
  const animateRefs = useRef();
  animateRefs.current = [
    [animateRef1, sectionRef1],
    [animateRef2, sectionRef2],
    [animateRef3, sectionRef3],
    [animateRef4, sectionRef4],
    [animateRef5, sectionRef5]
  ];

  useEffect(() => {
    let ctx = gsap.context(() => {
      animateRefs.current.forEach((refs) => {
        ScrollTrigger.create({
          trigger: refs[0].current,
          start: 'top 30%',
          onEnter: () => {
            gsap.to(refs[1].current, { opacity: 1, y: 0, duration: 0.7 });
          }
        });
      });
    });
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.2) {
            logoRef.current.style.opacity = 1;
            logoRef.current.style.transform = 'translateY(20px)';
          } else {
            logoRef.current.style.opacity = 0;
            logoRef.current.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: [0, 0.2, 1] }
    );
    observer.observe(containerRef.current);
  }, []);

  return (
    <div className="sectionsContainer" ref={containerRef}>
      <img ref={logoRef} src={logo} alt="" className="sectionsContainer__logo"></img>
      {contentData.map((tile, i) => {
        return (
          <section
            className={`sections sections-${i}`}
            key={tile.content}
            ref={animateRefs.current[i][0]}
          >
            <div className="sections-gradient" />
            <video muted autoPlay loop playsInline className="videoloop videoloop-d">
              <source src={tile.videoL} type="video/mp4" />
              Your browser does not support HTML video.
            </video>
            <video muted autoPlay loop playsInline className="videoloop videoloop-m">
              <source src={tile.videoS} type="video/mp4" />
              Your browser does not support HTML video.
            </video>

            <div
              className={`sections__text sections__text-sections sections__text--${i}`}
              ref={animateRefs.current[i][1]}
            >
              <h2>{tile.title}</h2>
              <p>{tile.body}</p>
              <a id={tile.content} href={tile.url} target="_blank" rel="sponsored">
                {tile.button}
              </a>
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default Sections;
